import { LANGUAGE_CODE, LANGUAGE_DEFAULT } from '@src/configs/const.config'
import { checkAuth, getLocalStored, setLocalStored } from '@src/libs/localStorage'
import { queryClient } from '@src/queries'
import { useQueryProfile } from '@src/queries/hooks'
import { Spin } from 'antd'
import { memo, useEffect } from 'react'

function LoadingApp({ children, loaded }: { children: JSX.Element; loaded: boolean }) {
  const token: string = checkAuth()
  const { isLoading: qrProfileLoading } = useQueryProfile(token)
  useEffect(() => {
    const lang = getLocalStored('lang')
    if (!lang || !LANGUAGE_CODE.includes(lang)) {
      setLocalStored('lang', LANGUAGE_DEFAULT)
      queryClient.refetchQueries()
    }
  }, [])
  if (qrProfileLoading && loaded)
    return (
      <div className="loading-data-main">
        <Spin tip="Loading data" />
      </div>
    )
  return children
}

export default memo(LoadingApp)
